import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { changeHeader } from '../../../redux/reducer/headerSlice';
import trans_pic from "../../../assests/images/payment_image.png";
import { useTranslation } from "react-i18next";
import { BsArrowRight } from "react-icons/bs";

const Dashboard = () => {
    const { t } = useTranslation();
    const { buttonselect, AdminDashboard, TicketSelected, Selectaticket } = t("admin", { returnObjects: true });

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(changeHeader(AdminDashboard));
    }, [dispatch, AdminDashboard]);

    return (
        <main className="w-full min-h-[calc(100vh-120px)] flex items-center justify-center p-6">

            {/* Card container */}
            <div className="relative w-full max-w-lg">

                {/* Glow behind card */}
                <div className="absolute inset-0 bg-violet-600/10 blur-3xl rounded-3xl scale-110 pointer-events-none" />

                {/* Main card */}
                <div className="
                    relative
                    bg-[#111827] bg-[#111827] 
                    border border-white/6 border-gray-200
                    rounded-3xl overflow-hidden
                    shadow-2xl
                ">

                    {/* Top decorative strip */}
                    <div className="h-1 w-full bg-gradient-to-r from-violet-600 via-purple-500 to-violet-800" />

                    {/* Dot grid pattern overlay */}
                    <div
                        className="absolute inset-0 opacity-[0.03] pointer-events-none"
                        style={{
                            backgroundImage: 'radial-gradient(circle, #ffffff 1px, transparent 1px)',
                            backgroundSize: '24px 24px',
                        }}
                    />

                    <div className="relative px-10 py-10 flex flex-col items-center text-center">

                        {/* Image with floating ring effect */}
                        <div className="relative mb-6">
                            {/* Outer pulse ring */}
                            <div className="absolute inset-0 rounded-full bg-violet-500/10 scale-125 blur-lg" />
                            <div className="
                                relative w-52 h-52 rounded-full
                                bg-gradient-to-br 
                                from-[#1a2236] to-[#0e1525]
                                from-violet-50 to-purple-100
                                flex items-center justify-center
                                border border-white/8
                                shadow-xl
                            ">
                                <img
                                    src={trans_pic}
                                    alt="ticket"
                                    className="w-36 h-36 object-contain drop-shadow-xl"
                                />
                            </div>
                        </div>

                        {/* Title */}
                        <h2 className="text-2xl font-bold text-white leading-snug mb-2">
                            {TicketSelected || "No Ticket Selected"}
                        </h2>

                        {/* Subtitle */}
                        <p className="text-sm text-white/80 max-w-[260px] leading-relaxed mb-8">
                            {Selectaticket || "Select a support ticket to view details and manage your requests."}
                        </p>

                        {/* CTA */}
                        <Link to="/admin/support" className="w-full">
                            <button className="
                                group w-full flex items-center justify-center gap-3
                                bg-violet-600 hover:bg-violet-500
                                text-white font-medium text-sm
                                px-6 py-3.5 rounded-2xl
                                shadow-lg shadow-violet-600/30
                                transition-all duration-200
                                active:scale-[0.98]
                            ">
                                {buttonselect || "Select a Ticket"}
                                    <BsArrowRight/>
                            </button>
                        </Link>

                    </div>
                </div>
            </div>

        </main>
    );
};

export default Dashboard;